<template>
	<div class="adminMediaPreview">
		<div class="d-flex flex-row ">
			<div class="search-input">
				<b-form-input
					class="input-search"
					:placeholder="$t('userDashboard.messages.search')"
					v-model="config.searchAdminMedia"
				></b-form-input>
				<MagnifyIcon class="icon-search" />
			</div>
			<b-button class="add-button ml-3" v-b-modal.add-media @click="reset()">{{$t('adminMedia.addFile')}}</b-button>
		</div>
		<div
			class="content-body-div"
			:class="{ 'no-data': !adminMedias.length }"
		>
			<b-row no-gutters>
				<div
					v-for="(item, index) in adminMedias"
					:key="index"
					v-b-tooltip
					:title="item.name"
				>
					<b-col cols="3">
						<div class="template-item">
							<div class="button-div" style="position: absolute;">
								<b-button @click="edit(item)"><IconEdit/></b-button>
								<b-button @click="deleteFile(item)"><IconTrash/></b-button>
							</div>
							<div @click="showPopup(item)"
								class="file"
								:style="{ backgroundImage: 'url(' + item.url + ')' }"
							></div>
							<div class="title">{{ item.name }}</div>
						</div>
					</b-col>
				</div>
			</b-row>
			<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
				<span slot="no-results">
					<b-alert show variant="light">{{
						$t('adminDashboard.list.dataEmpty')
					}}</b-alert>
				</span>
				<span slot="no-more"></span>
			</infinite-loading>
		</div>
		<b-modal
			id="popup"
			modal-class="modal-adminMedia-template"
			size="xl"
			centered
			hide-header
			hide-footer
		>
			<div class="d-flex flex-row justify-content-end align-items-end ">
				<div @click="hidePopup" style="cursor: pointer;" class="m-3">
					<IconClose style="width: 25px; height: 25px;" />
				</div>
        	</div>
			<div class=" d-flex flex-column justify-content-center align-items-center align-self-center mt-3">
				<b-img
					:src="adminMedia.url"
					v-if="adminMedia"
					:fluid="true"
					style="background: #e4e4e4; padding: 30px;"
					:alt="$t('altTag',{ affiliate: $root.affiliate })"
				></b-img>
				<h5 class="emailtemplate-render mt-2" v-html="adminMedia.name" v-if="adminMedia"></h5>
				<div class="d-flex flex-row  m-3" style="width:70%">
					<b-form-input :value="adminMedia.url" disabled v-if="adminMedia" id="copyLinkInput" class="copyLinkInput"></b-form-input>
					<!-- <b-button @click="doCopy">Copy</b-button> -->
				</div>
			</div>
		</b-modal>
		<b-modal
			id="add-media"
			modal-class="modal-adminMedia-template"
			size="xl"
			centered
			hide-header
			hide-footer
			no-close-on-backdrop
			no-close-on-esc
		>
			<div class=" d-flex flex-column ">
				<div
					class="d-flex flex-column justify-content-start m-3"
					>
					<label  :class="{
						'input-error': validateErrors ? validateErrors.files : false,
					}">{{$t('adminMedia.file')}}</label>
					<div class=" d-flex flex-column justify-content-center align-items-center align-self-center mt-3">
						<b-img
							:src="adminMedia.url"
							v-if="adminMedia.id"
							:fluid="true"
							:alt="$t('altTag',{ affiliate: $root.affiliate })"
						></b-img>
					</div>
					<Fileuploader v-if="!adminMedia.id"
						name="files"
						:maxFiles="'1'						"
						:class="{
							'input-error': validateErrors
								? validateErrors.filesError
								: false
						}"
						:accept="'jpg, png, jpeg, gif, svg, pdf, video/*'"
						:maxSize="'10'"
						:multiple="true"
						@childToParent="getFile"
						:fileUploaded="arrFilesUploaded"
						:theme="'thumbnails'"
						:changeInput="' '"
					/>
				</div>
				<div
					class="d-flex flex-column justify-content-start m-3"
					>
					<label  :class="{
						'input-error': validateErrors ? validateErrors.name : false,
					}">{{$t('adminMedia.name')}}</label>
					
					<b-form-input
               
						class="input-search"
						ref="searchInput"
						:placeholder="$t('adminMedia.name')"
						v-model="adminMedia.name"
					></b-form-input>
				</div>
				 <div
					class="d-flex flex-row justify-content-center align-self-center m-3"
					>
					<b-button class="cancel-button ml-3" @click="hideAddMedia()" 
						>{{$t('adminMedia.close')}}</b-button
					>
					<b-button class="add-button ml-3" @click="checkForm()"
						>{{adminMedia.id?$t('adminMedia.update'):$t('adminMedia.add')}}</b-button
					>
					
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
// Icons
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import IconTrash from "@/components/icons/IconTrash";
import IconClose from "@/components/icons/IconClose";
import IconEdit from "@/components/icons/IconEdit";
import InfiniteLoading from 'vue-infinite-loading';
import Fileuploader from '@/components/newFileuploader/index';
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';

export default {
	components: {
		MagnifyIcon,
		InfiniteLoading,
		Fileuploader,
		IconTrash,
		IconClose,
		IconEdit
	},
	data() {
		return {
			config: {
				limit: 10,
				take: 10,
				page: 1,
				searchAdminMedia: ''
			},
			adminMedias:[],
			adminMedia:{
				files:null,
				name:null,
			},
			arrFilesUploaded: [],
			validateErrors: {},
			validateInputDynamic: [null],
		};
	},
	
	computed: {
		
	},
	methods: {
		...mapActions('AdminMediaController', ['GET_MEDIA', 'ADD_FILES', 'DELETE_FILE', 'UPDATE_FILES']),

		getFile(ev) {
			this.adminMedia.files = ev;
		},
		doCopy(e) {
			let selectEl = $(e.target).parents('.form-control').find('.copyLinkInput')[0];
			selectEl.select();
			document.execCommand("copy");
		},
		async infiniteHandler($state) {
			console.log("this.config",this.config)
			let response = await this.GET_MEDIA({
				search: this.config.searchAdminMedia || null,
				take: this.config.take,
				page: this.config.page
			});
			if (response) {
				if (this.config.page == 1) {
						this.adminMedias = response.data.data;
				} else {
					response.data.data.forEach(elm => {
						this.adminMedias.push(elm);
					});
				}
				if (!response.data.data) {
					return $state.stateChanger?$state.stateChanger.complete():$state.complete();
				}
				if (response.data.data.length > 0) {
					this.config.take = await this.config.limit;
					this.config.page += await 1;
					await $state.stateChanger?$state.stateChanger.loaded():$state.loaded();
				} else await $state.stateChanger?$state.stateChanger.complete():$state.complete();
			}
		},
		searchAdminMedias(value) {
			setTimeout(async () => {
				this.config.searchAdminMedia = value;
				this.config.take = this.config.limit;
				this.config.page = 1;
				this.adminMedias=[];
				this.infiniteHandler(this.$refs.infiniteLoading);
				
			}, 500);
		},
		showPopup(item) {
			this.adminMedia = item;
			this.$bvModal.show('popup');
		},
		checkForm(e) {
			this.countError = 0;
			this.validateErrors = {};
			this.isValidate = true;
			if (this.adminMedia.name && this.adminMedia.name.match(/[\u1000-\uFFFF]+/g)) {
				this.validateErrors[`name`] = true;
				this.countError++;
				this.makeToastError(this.$t("Marks or special characters are not allowed"));
				return;
			}
			if (!this.adminMedia.name) {
				this.validateErrors[`name`] = true;
				this.countError++;
			}
			if (!this.adminMedia.files&&!this.adminMedia.id) {
				this.validateErrors[`files`] = true;
				this.countError++;
			}
			console.log("this.adminMedia", this.adminMedia);
			console.log("this.validateErrors", this.validateErrors);
			this.addAgency();
		},
		addAgency() {
			this.$root.loading=true;
			if (!this.countError) {
				let filesData = new FormData();
				filesData.append("name", this.adminMedia.name);
				if(!this.adminMedia.id){
					this.adminMedia.files.forEach((elm)=>{
						filesData.append("file", elm.file);
					})
				}
				if(!this.adminMedia.id){
					this.ADD_FILES(filesData).then((data) => {
						this.hideAddMedia();
						this.config.page=1;
						this.infiniteHandler(this.$refs.infiniteLoading);
						this.$root.loading=false;
						console.log("data", data);
						this.reset();
					}).catch((err)=>{
						console.log('err',err);
						this.$root.loading=false;
						if(err.data.status==400){
							this.showToast('File Limit Exceeded',"danger");
						}else{
							this.showToast(this.$t('adminMedia.createdError'),"danger");
						}
					});
				}else{
					this.UPDATE_FILES({mediaId:this.adminMedia.id,filesData:filesData}).then((data) => {
						this.hideAddMedia();
						this.config.page=1;
						this.infiniteHandler(this.$refs.infiniteLoading);
						this.$root.loading=false;
						console.log("data", data);
						this.reset();
					}).catch((err)=>{
						console.log('err',err);
						this.$root.loading=false;
						if(err.data.status==400){
							this.showToast('File Limit Exceeded',"danger");
						}else{
							this.showToast(this.$t('adminMedia.createdError'),"danger");
						}
					});
				}
				
			} else {
				this.$root.loading=false;
				this.showToast("Check the form!","danger");
			}
		},
		reset(){
			this.adminMedia={
				files:null,
				name:null
			}
		},
		deleteFile(file){
			this.$swal({
				title: this.$i18n.t('userDashboard.userManage.modalDelete.title'),
				text: file.name,
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				cancelButtonColor: 'var(--projectPrimaryColor) !important',
				confirmButtonColor: 'var(--deleteButtonBgColor) !important',
				cancelButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnConfirm'
				),
				confirmButtonText: this.$i18n.t(
					'userDashboard.userManage.modal.btnCancel'
				),
				preConfirm: () => {
					this.$root.loading=true;
					this.DELETE_FILE({id:file.id}).then((data)=>{
						this.showToast("File deleted!","success");
						this.config.page=1;
						this.$root.loading=false;
						this.infiniteHandler(this.$refs.infiniteLoading);
						
					}).catch((err)=>{
						this.$root.loading=false;
						this.showToast(this.$t('agency.createdError'),"danger");
					});
				}
			});
		},
		showToast(text,type){
			this.$bvToast.toast(text, {
			title: text,
			variant: type,
			solid: true,
			});
		},
		hidePopup(){
			this.$bvModal.hide("popup");
		},
		hideAddMedia(){
			this.$bvModal.hide("add-media");
		},
		edit(item){
			this.adminMedia=item;
			this.$bvModal.show('add-media');
		}
	},
	watch:{
		'config.searchAdminMedia': {
			deep: true,
			handler: _.debounce(function () {
				this.config.page = 1;
				this.$forceUpdate();
				this.infiniteHandler(this.$refs.infiniteLoading)
			}, 800),
		}
	},
};
</script>
<style lang="scss" scoped>
@import 'adminMedia.scss';
</style>
